import PropTypes from 'prop-types';
import {
    BREAKDOWN_VARIANTS,
    METRIC_TONES,
    MONITOR_STATUS,
    SENTIMENTS,
    VERDICT_OUTCOMES,
    VIEW_TYPES,
} from './constants';

export const displayFormatShape = PropTypes.shape({
    type: PropTypes.string,
    symbol: PropTypes.string,
    precision: PropTypes.number,
});

export const verdictValueShape = PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    field: PropTypes.string,
    delta: PropTypes.number,
    tone: PropTypes.oneOf(Object.values(METRIC_TONES)),
    display_format: displayFormatShape,
});

export const statsViewShape = PropTypes.shape({
    type: PropTypes.oneOf([VIEW_TYPES.STATS]).isRequired,
    items: PropTypes.arrayOf(verdictValueShape).isRequired,
    truncated_count: PropTypes.number,
});

export const breakdownListViewShape = PropTypes.shape({
    type: PropTypes.oneOf([VIEW_TYPES.BREAKDOWN]).isRequired,
    variant: PropTypes.oneOf([BREAKDOWN_VARIANTS.LIST]).isRequired,
    ranked: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(verdictValueShape).isRequired,
    truncated_count: PropTypes.number,
});

export const tableColumnShape = PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    display_format: displayFormatShape,
});

export const tableRowShape = PropTypes.shape({
    label: PropTypes.string.isRequired,
    values: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])).isRequired,
});

export const breakdownTableViewShape = PropTypes.shape({
    type: PropTypes.oneOf([VIEW_TYPES.BREAKDOWN]).isRequired,
    variant: PropTypes.oneOf([BREAKDOWN_VARIANTS.TABLE]).isRequired,
    columns: PropTypes.arrayOf(tableColumnShape).isRequired,
    rows: PropTypes.arrayOf(tableRowShape).isRequired,
    truncated_count: PropTypes.number,
});

export const trendSeriesShape = PropTypes.shape({
    label: PropTypes.string.isRequired,
    points: PropTypes.arrayOf(
        PropTypes.shape({
            timestamp: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })
    ).isRequired,
    display_format: displayFormatShape,
});

export const trendViewShape = PropTypes.shape({
    type: PropTypes.oneOf([VIEW_TYPES.TREND]).isRequired,
    series: PropTypes.arrayOf(trendSeriesShape).isRequired,
    truncated_count: PropTypes.number,
});

export const verdictViewShape = PropTypes.oneOfType([
    statsViewShape,
    breakdownListViewShape,
    breakdownTableViewShape,
    trendViewShape,
]);

export const verdictShape = PropTypes.shape({
    outcome: PropTypes.oneOf(Object.values(VERDICT_OUTCOMES)).isRequired,
    sentiment: PropTypes.oneOf(Object.values(SENTIMENTS)),
    should_notify: PropTypes.bool,
    headline: PropTypes.string,
    supporting_facts: PropTypes.string,
    view: verdictViewShape,
});

export const monitorShape = PropTypes.shape({
    monitor_id: PropTypes.string.isRequired,
    owner_id: PropTypes.string,
    organization_id: PropTypes.number,
    user_query: PropTypes.string.isRequired,
    schedule: PropTypes.string.isRequired,
    next_run_at: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(MONITOR_STATUS)).isRequired,
    claimed_at: PropTypes.string,
    latest_verdict: verdictShape,
    session_id: PropTypes.string.isRequired,
    active_run_id: PropTypes.string,
    slack_channels: PropTypes.arrayOf(
        PropTypes.shape({
            channel_name: PropTypes.string.isRequired,
        })
    ),
});
